import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import {
  CookingKitchenSearchFoods,
  cookingStorySearchItem,
  kitchenItem,
  kitchenSearchItem,
} from 'src/app/core/model/api-response/cooking-story-model';
import { foodUnitRatioArraySample } from 'src/app/core/model/api-response/persoanl-response-model';
import { FoodModel } from 'src/app/core/model/object/diet-food-model';
import { CookingStoryGroceryService } from 'src/app/data/repository/cooking-story/cooking-story-grocery.service';
import { CookingStoryGroceryApiService } from 'src/app/data/repository/cooking-story/cooking-story-kitchen-api.service';
import { CookingStoryKitchenDataService } from 'src/app/data/repository/cooking-story/cooking-story-kitchen-data.service';
import { RecipeService } from 'src/app/data/repository/recipe-repository/recipe.service';
import { LoadingShared } from 'src/app/presentation/general/shared/loading-shared';
import { KitcchenQuickAddComponent } from '../kitcchen-quick-add/kitcchen-quick-add.component';
import { KitchenSearchEditComponent } from './kitchen-search-edit/kitchen-search-edit.component';

@Component({
  selector: 'app-kitchen-search',
  templateUrl: './kitchen-search.component.html',
  styleUrls: ['./kitchen-search.component.scss'],
})
export class KitchenSearchComponent implements OnInit, OnDestroy {
  public isSearch: boolean = false;
  public searchText: string;
  public selectedItem: string[] = [];
  txtQueryChanged: Subject<string> = new Subject<string>();
  public kitchenItems: cookingStorySearchItem[] = [];
  unitList;
  mostUsekitchenItem: kitchenItem[];
  subscriptions: Subscription[] = [];
  searched: boolean = false;
  showLoading = false;
  notfound: boolean = false;
  showSelected: boolean = false;

  constructor(
    private recipeService: RecipeService,
    private matBottomSheet: MatBottomSheet,
    private CookingStoryKitchenApiService: CookingStoryGroceryApiService,
    private cookingStoryKitchenDataService: CookingStoryKitchenDataService,
    private loadingShared: LoadingShared,
    private CookingStoryGroceryService: CookingStoryGroceryService
  ) {}

  async ngOnInit() {
    this.cookingStoryKitchenDataService.clearKitchenItems();
    this.CookingStoryKitchenApiService.getKitchenMostUse().then(async (res) => {
      const data = res.getData().getKitchenHomeItemResponce().kitchen;

      this.mostUsekitchenItem =
        await this.cookingStoryKitchenDataService.prepearMostUseFood(data);
    });
    const q = this.txtQueryChanged
      .pipe(debounceTime(1000), distinctUntilChanged())
      .subscribe((data) => {
        this.getKitchenItem(data);
      });
    const show = this.loadingShared.showLoadingObs$.subscribe((show) => {
      if (show) {
        setTimeout(() => {
          this.showLoading = true;
        }, 0);
      }
    });
    const hide = this.loadingShared.hideLoadingObs$.subscribe((hide) => {
      if (hide) {
        setTimeout(() => {
          this.showLoading = false;
        }, 0);
      }
    });
    this.subscriptions.push(q, show, hide);
    this.unitList = await this.cookingStoryKitchenDataService.getUnitList();
  }
  goBack() {
    this.recipeService.back();
  }
  search(query: string) {
    query = query.trim();
    if (query.length <= 0 || query == '') {
      this.isSearch = false;
    } else {
      this.isSearch = true;
      this.searched = true;
      this.txtQueryChanged.next(query);
    }
  }
  onkeydown(e) {
    if (
      (e.key == 'Backspace' && this.searchText.length <= 0) ||
      this.searchText === ''
    ) {
      this.isSearch = false;
    }
  }
  cancel() {
    this.isSearch = false;
    this.searchText = null;
    this.kitchenItems = [];
    this.notfound = false;
    this.showSelected = true;
  }
  clear() {
    this.searchText = null;
    this.isSearch = false;
    this.notfound = false;
    this.showSelected = true;
  }
  flatAndFilterUN(data: CookingKitchenSearchFoods[][]) {
    let flated = data.flat();
    let filtered = flated.filter((e) => e !== undefined);
    return filtered[0];
  }
  toggleSelect(id: string) {
    let item = this.selectedItem.find((x) => x == id);
    let data;
    let selectedId;
    if (this.kitchenItems && this.kitchenItems.length > 0) {
      const kitchenlistItem = this.kitchenItems.map((d) => {
        return d.foods.filter((x) => x._id == id);
      });
      let selectedItem = this.flatAndFilterUN(kitchenlistItem);
      selectedId = selectedItem._id;

      data = new kitchenSearchItem(
        id,
        null,
        null,
        null,
        '',
        '',
        null,
        selectedItem.name,
        null,
        false,
        selectedId
      );

      // const newUnit = new foodUnitRatioArraySample(
      //   1,
      //   'nothing',
      //   'nothing',
      //   '',
      //   ''
      // );
      // (selectedItem.food as FoodModel).foodUnitRatioArray.push(newUnit as any);
    } else if (this.mostUsekitchenItem && this.mostUsekitchenItem.length > 0) {
      const selectedItem = this.mostUsekitchenItem.filter((d) => {
        return d._id == id;
      })[0];
      selectedId = selectedItem._id;

      data = new kitchenSearchItem(
        (selectedItem.food as FoodModel)._id,
        null,
        selectedItem.amount,
        (selectedItem.food as FoodModel).primaryFoodUnit,
        selectedItem.unitDescription,
        selectedItem.description,
        null,
        (selectedItem.food as FoodModel).name,
        (selectedItem.food as FoodModel).foodUnitRatioArray as any,
        false,
        selectedId
      );

      const newUnit = new foodUnitRatioArraySample(
        1,
        'nothing',
        'nothing',
        '',
        ''
      );
      (selectedItem.food as FoodModel).foodUnitRatioArray.push(newUnit as any);
    } else {
      const selectedItem = this.cookingStoryKitchenDataService.getItem(id);

      selectedId = selectedItem.id;

      data = selectedItem;
    }

    if (item) {
      this.selectedItem = this.selectedItem.filter((x) => x != selectedId);
    } else {
      this.selectedItem.push(selectedId);
    }

    this.cookingStoryKitchenDataService.addItem(data);
  }
  checkSelect(id: string): boolean {
    let item = this.selectedItem.find((x) => {
      return x == id;
    });

    if (!item) {
      return true;
    } else {
      return false;
    }
  }
  openCartBottomSheet(food, id) {
    this.cookingStoryKitchenDataService.changeType('search');
    const bottomSheetRef = this.matBottomSheet.open(
      KitchenSearchEditComponent,
      {
        panelClass: 'custom-bottomsheet-container',
        data: { id, food },
      }
    );
    const sub = bottomSheetRef
      .afterDismissed()
      .subscribe((dataFromChild) => {});
    this.subscriptions.push(sub);
  }
  getSelectedItem() {
    return this.cookingStoryKitchenDataService.getItems();
  }
  getKitchenItem(q: string) {
    this.notfound = false;
    this.loadingShared.showLoading();
    this.CookingStoryKitchenApiService.getKitchenSearch(q).then(async (res) => {
      const data = res.getData().getCookingStoryKitchenResponce().list;
      if (data.length == 0) this.notfound = true;
      this.kitchenItems =
        await this.cookingStoryKitchenDataService.prepearSearchFood(data);
      this.loadingShared.hideLoading();
    });
  }
  checkForDefine(id: string) {
    let item = this.cookingStoryKitchenDataService.getItem(id);

    if (item && item.save && item.amount) {
      if (!item.unitDescription) {
        return item.amount;
      }

      return item.amount + ' ' + item.unitDescription;
    }
    return 'مقدار و تاریخ';
  }

  saveItems() {
    if (this.selectedItem.length > 0) {
      this.loadingShared.showLoading();
      this.cookingStoryKitchenDataService.saveKitchenData().then((res) => {
        if (res) {
          this.loadingShared.hideLoading();
          this.goBack();
          this.CookingStoryGroceryService.itemAdded.next('آشپزخانه');
        }
      });
    }
  }
  ngOnDestroy() {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
  }
  quickAdd() {
    this.cookingStoryKitchenDataService.changeType('search');
    this.cookingStoryKitchenDataService.changeActiveItem(null);

    const bottomSheetRef = this.matBottomSheet.open(KitcchenQuickAddComponent, {
      panelClass: 'custom-bottomsheet-container',
      data: { text: this.searchText },
    });
    const sub = bottomSheetRef
      .afterDismissed()
      .subscribe((dataFromChild) => {});
    this.subscriptions.push(sub);
  }
}
